import React from 'react';

const DataSegments = () => {
  return <div>Data Segments Page</div>;
};

export default DataSegments;
